import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */);
// axios.defaults.baseURL = 'http://localhost:3000/'   //加前缀
// axios.defaults.withCredentials = true   //允许跨域
// global.axios = axios    //全局化

Vue.use(VueAxios,axios);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  // document.body.scrollTop = 0;
  window.scrollTo(0,0);
  next();
});

new Vue({
  el: '#app',
  //让vue知道我们的路由规则
  router, //可以简写router
  render: c => c(App),
});
